import(/* webpackMode: "eager" */ "/pupas/app/globals.css");
import(/* webpackMode: "eager" */ "/pupas/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/pupas/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/pupas/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/pupas/components/ui/tooltip.tsx")